import { DESKTOP } from "@/themes/device";
import styled from "@emotion/styled";
import {
  grayScale,
  mBody4,
  mHeader1,
  mTitle2,
  wArticle2,
  wBody3,
  wHeader2,
  wTitle4,
} from "@teamsparta/design-system";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 328px;

  ${DESKTOP} {
    width: initial;
    max-width: 1152px;
  }
`;

export const Title = styled.h3`
  ${mHeader1}
  color: ${grayScale.gray100};

  ${DESKTOP} {
    ${wHeader2}
    color: ${grayScale.gray100};
    text-align: center;
  }
`;

export const Brands = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 40px;

  ${DESKTOP} {
    flex-direction: row;
    margin: 80px 0;
  }
`;

export const Brand = styled.article`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border: 1px solid ${grayScale.gray20};
  border-radius: 8px;
`;

export const BrandInfo = styled.div``;

export const BrandName = styled.h4`
  ${mTitle2}
  color: ${grayScale.gray90};
  ${DESKTOP} {
    ${wTitle4}
    color: ${grayScale.gray90};
  }
`;

export const BrandDesc = styled.p`
  ${mBody4}
  color: ${grayScale.gray70};

  ${DESKTOP} {
    ${wBody3}
    color: ${grayScale.gray70};
  }
`;

export const BrandLogo = styled.div<{ logoName: string }>`
  ${({ logoName }) => {
    if (logoName === "hanghae") {
      return `
          width: 74px;
          height: 24px;
    `;
    }
    if (logoName === "chang") {
      return `
          width: 42px;
          height: 29px;
    `;
    }
    if (logoName === "swc") {
      return `
          width: 90px;
          height: 26px;
    `;
    }
  }}

  ${DESKTOP} {
    ${({ logoName }) => {
      if (logoName === "hanghae") {
        return `
          width: 92.5px;
          height: 30px;
    `;
      }
      if (logoName === "chang") {
        return `
          width: 57px;
          height: 40px;
    `;
      }
      if (logoName === "swc") {
        return `
          width: 100px;
          height: 30px;
    `;
      }
    }}
  }
`;

export const Desc = styled.p`
  ${mBody4}
  color: ${grayScale.gray70};
  margin-top: 40px;

  br {
    display: none;
  }

  ${DESKTOP} {
    ${wArticle2}
    color: ${grayScale.gray80};
    font-weight: 400;
    text-align: center;
    margin: 0;

    br {
      display: block;
    }
  }
`;
